import React from 'react';
import classnames from 'classnames';
import * as styles from '@utils/tableViewscss/TableViewBoard.module.scss';
import { GenericCell } from '@components/design/migrated/Table';
import { PerformanceAnalysisboardPg } from '@models/PerformanceAnalysisboard';
import { ShareType } from '@utils/pageConfig/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import {
  displayPrimaryCell,
  displaySecColorForPositiveGrowth,
  displaySecondaryCell,
} from '@utils/hook/tableCellConst/TableCellConst';
import { modifiedPATableGrandTotalToTotalValue } from '@utils/TotalUtils';

interface Props {
  headerKey: string;
  performanceAnalysisboardPg: PerformanceAnalysisboardPg;
  isStickyRow?: boolean;
  isCategoryGroup: boolean;
  sortedColumn: string;
  selectedGrowthType: GrowthTypes;
  selectedShareType: ShareType;
  currencySymbol: string;
}

const PerformanceAnalysisTableCell: React.FC<Props> = ({
  headerKey,
  performanceAnalysisboardPg,
  isStickyRow,
  sortedColumn,
  isCategoryGroup,
  selectedGrowthType,
  selectedShareType,
  currencySymbol,
}) => {
  const modifiedPerformanceAnalysisPg = modifiedPATableGrandTotalToTotalValue(performanceAnalysisboardPg);

  if (isCategoryGroup) {
    return (
      <td
        key={modifiedPerformanceAnalysisPg.segmentOrPg}
        className={classnames([
          styles.TableViewboard__TableCell,
          styles.TableViewboard__TableCell_Total,
          { [styles['TableViewboard__StickyRow']]: isStickyRow },
        ])}
      >
        <div>
          <p>{modifiedPerformanceAnalysisPg.segmentOrPg}</p>
        </div>
      </td>
    );
  }

  return (
    <td
      className={classnames([
        styles.TableViewboard__TableCell,
        {
          [styles['TableViewboard__SortedCell']]: sortedColumn === headerKey,
          [styles['TableViewboard__StickyRow']]: isStickyRow,
        },
      ])}
    >
      <GenericCell
        primary={displayPrimaryCell(headerKey, modifiedPerformanceAnalysisPg, currencySymbol, true, selectedShareType)}
        secondary={displaySecondaryCell(
          headerKey,
          modifiedPerformanceAnalysisPg,
          selectedGrowthType,
          currencySymbol,
          true,
          selectedShareType,
        )}
        secondaryColor={displaySecColorForPositiveGrowth(
          headerKey,
          modifiedPerformanceAnalysisPg,
          selectedGrowthType,
          true,
          selectedShareType,
        )}
      />
    </td>
  );
};

export default PerformanceAnalysisTableCell;
